module.exports = [
    {
        "id_primary": "1757120",
        "id_template": "107777",
        "id_display_style": "1",
        "ordinal": "1",
        "field_key": "property_address",
        "content_group": "data",
        "display_group": "A",
        "max_length": "45",
        "apply_drop_cap": null,
        "enable_limit_override": "0",
        "display_label": "Property Address",
        "default_value": "",
        "required": "0",
        "map_field_id": null,
        "id_ddf_master": null,
        "id_validation_field": null,
        "id_content_group": null,
        "is_editable": "1",
        "visible": "1",
        "id_message": null,
        "allow_suggested_comments": "1"
    },

    {
    "id_primary": "1757121",
    "id_template": "107777",
    "id_display_style": "1",
    "ordinal": "1",
    "field_key": "property_price",
    "content_group": "data",
    "display_group": "A",
    "max_length": "10",
    "apply_drop_cap": null,
    "enable_limit_override": "0",
    "display_label": "Price",
    "default_value": "",
    "required": "0",
    "map_field_id": null,
    "id_ddf_master": null,
    "id_validation_field": null,
    "id_content_group": null,
    "is_editable": "1",
    "visible": "1",
    "id_message": null,
    "allow_suggested_comments": "1"
}, {
    "id_primary": "1757122",
    "id_template": "107777",
    "id_display_style": "4",
    "ordinal": "1",
    "field_key": "field_2",
    "content_group": "comments",
    "display_group": "A",
    "max_length": "715",
    "apply_drop_cap": null,
    "enable_limit_override": "1",
    "display_label": "Postcard Comments",
    "default_value": "",
    "required": "0",
    "map_field_id": null,
    "id_ddf_master": null,
    "id_validation_field": null,
    "id_content_group": null,
    "is_editable": "1",
    "visible": "1",
    "id_message": null,
    "allow_suggested_comments": "1"
}, {
    "id_primary": "1757125",
    "id_template": "107777",
    "id_display_style": "1",
    "ordinal": "2",
    "field_key": "field_13",
    "content_group": "specification",
    "display_group": "B",
    "max_length": "3",
    "apply_drop_cap": "",
    "enable_limit_override": "0",
    "display_label": "Bathrooms",
    "default_value": "",
    "required": "0",
    "map_field_id": null,
    "id_ddf_master": null,
    "id_validation_field": null,
    "id_content_group": null,
    "is_editable": "1",
    "visible": "1",
    "id_message": null,
    "allow_suggested_comments": "1"
}, {
    "id_primary": "1757126",
    "id_template": "107777",
    "id_display_style": "1",
    "ordinal": "3",
    "field_key": "field_66",
    "content_group": "specification",
    "display_group": "B",
    "max_length": "20",
    "apply_drop_cap": "",
    "enable_limit_override": "0",
    "display_label": "Just Listed \/ Just Sold",
    "default_value": "",
    "required": "0",
    "map_field_id": null,
    "id_ddf_master": null,
    "id_validation_field": null,
    "id_content_group": null,
    "is_editable": "1",
    "visible": "1",
    "id_message": null,
    "allow_suggested_comments": "1"
}, {
    "id_primary": "1757127",
    "id_template": "107777",
    "id_display_style": "1",
    "ordinal": "1",
    "field_key": "field_15",
    "content_group": "specification",
    "display_group": "B",
    "max_length": "2",
    "apply_drop_cap": "",
    "enable_limit_override": "0",
    "display_label": "Bedrooms",
    "default_value": "",
    "required": "0",
    "map_field_id": null,
    "id_ddf_master": null,
    "id_validation_field": null,
    "id_content_group": null,
    "is_editable": "1",
    "visible": "1",
    "id_message": null,
    "allow_suggested_comments": "1"
}, {
    "id_primary": "1760472",
    "id_template": "107777",
    "id_display_style": "1",
    "ordinal": "4",
    "field_key": "field_67",
    "content_group": "specification",
    "display_group": "B",
    "max_length": "20",
    "apply_drop_cap": "",
    "enable_limit_override": "0",
    "display_label": "Broker Name",
    "default_value": "",
    "required": "0",
    "map_field_id": null,
    "id_ddf_master": null,
    "id_validation_field": null,
    "id_content_group": null,
    "is_editable": "1",
    "visible": "1",
    "id_message": null,
    "allow_suggested_comments": "1"
}, {
    "id_primary": "1760473",
    "id_template": "107777",
    "id_display_style": "1",
    "ordinal": "5",
    "field_key": "field_68",
    "content_group": "specification",
    "display_group": "B",
    "max_length": "40",
    "apply_drop_cap": "",
    "enable_limit_override": "0",
    "display_label": "Title",
    "default_value": "",
    "required": "0",
    "map_field_id": null,
    "id_ddf_master": null,
    "id_validation_field": null,
    "id_content_group": null,
    "is_editable": "1",
    "visible": "1",
    "id_message": null,
    "allow_suggested_comments": "1"
}, {
    "id_primary": "1760474",
    "id_template": "107777",
    "id_display_style": "3",
    "ordinal": "6",
    "field_key": "field_69",
    "content_group": "specification",
    "display_group": "B",
    "max_length": "20",
    "apply_drop_cap": "",
    "enable_limit_override": "0",
    "display_label": "Phone Label",
    "default_value": "[\u0022Office \u0022,\u0022Cell \u0022,\u0022Mobile \u0022,\u0022Direct\u0022]",
    "required": "0",
    "map_field_id": null,
    "id_ddf_master": null,
    "id_validation_field": null,
    "id_content_group": null,
    "is_editable": "1",
    "visible": "1",
    "id_message": null,
    "allow_suggested_comments": "1"
}, {
    "id_primary": "1760475",
    "id_template": "107777",
    "id_display_style": "1",
    "ordinal": "8",
    "field_key": "field_70",
    "content_group": "specification",
    "display_group": "B",
    "max_length": "35",
    "apply_drop_cap": "",
    "enable_limit_override": "0",
    "display_label": "Email Address",
    "default_value": "",
    "required": "0",
    "map_field_id": null,
    "id_ddf_master": null,
    "id_validation_field": null,
    "id_content_group": null,
    "is_editable": "1",
    "visible": "1",
    "id_message": null,
    "allow_suggested_comments": "1"
}, {
    "id_primary": "1760476",
    "id_template": "107777",
    "id_display_style": "1",
    "ordinal": "9",
    "field_key": "field_71",
    "content_group": "specification",
    "display_group": "B",
    "max_length": "35",
    "apply_drop_cap": "",
    "enable_limit_override": "0",
    "display_label": "Website",
    "default_value": "",
    "required": "0",
    "map_field_id": null,
    "id_ddf_master": null,
    "id_validation_field": null,
    "id_content_group": null,
    "is_editable": "1",
    "visible": "1",
    "id_message": null,
    "allow_suggested_comments": "1"
}, {
    "id_primary": "1902812",
    "id_template": "107777",
    "id_display_style": "1",
    "ordinal": "7",
    "field_key": "field_72",
    "content_group": "specification",
    "display_group": "B",
    "max_length": "20",
    "apply_drop_cap": "",
    "enable_limit_override": "0",
    "display_label": "Phone Number",
    "default_value": "",
    "required": "0",
    "map_field_id": null,
    "id_ddf_master": null,
    "id_validation_field": null,
    "id_content_group": null,
    "is_editable": "1",
    "visible": "1",
    "id_message": null,
    "allow_suggested_comments": "1"
}];